import axios from "axios";
import React, { useContext } from "react";
import { ProductContext } from "../../App";
import "./login.css";

function Login() {
  const product_context = useContext(ProductContext);
  const { setIsLoading, alert, setAlert, setUser } = product_context;

  const handleLoginSubmit = (e) => {
    setIsLoading(true);
    e.preventDefault();
    const user = {
      email: e.target.email.value,
      password: e.target.password.value,
    };

    axios
      .post(`${process.env.REACT_APP_SERVER_DOMAIN}/login`, user)
      .then((res) => {
        setUser(res.data.data);
        localStorage.setItem("token", JSON.stringify(res.data.token));
        setIsLoading(false);
      })
      .catch((err) => {
        setAlert({
          isOpen: true,
          message: err.response.data.msg || "Something Went Wrong",
          type: "danger",
        });
        setIsLoading(false);
      });
    setTimeout(() => {
      setAlert({ ...alert, isOpen: false });
    }, 5000);
  };

  return (
    <>
      <div className="container form my-5">
        <h2 className="text-center mb-3">Login</h2>
        <form
          className="d-flex flex-column align-items-center"
          onSubmit={handleLoginSubmit}
        >
          <div className="mb-3">
            <label htmlFor="email" className="form-label">
              Email address
            </label>
            <input
              placeholder="Enter Email"
              required
              type="email"
              className="input"
              name="email"
            />
          </div>
          <div className="mb-3">
            <label htmlFor="password" className="form-label">
              Password
            </label>
            <input
              placeholder="Enter Password"
              required
              type="password"
              className="input"
              name="password"
            />
          </div>
          <button type="submit" className="btn primary align-self-center mt-5">
            Sign In
          </button>
        </form>
      </div>
    </>
  );
}

export default Login;
